<div class="site-mobile-menu" [class.open]="isMobileMenuOpen">
  <div class="site-mobile-menu-header">
    <div class="site-mobile-menu-close mt-3">
      <span
        class="icon-close2 js-menu-toggle"
        (click)="toggleMobileMenu()"
      ></span>
    </div>
  </div>
  <div class="site-mobile-menu-body">
    <ul class="site-nav-wrap">
      <li [class.active]="currentRoute === '/home'">
        <a href="/home">Home</a>
      </li>
      <li [class.active]="currentRoute === '/music'">
        <a href="/music">Music</a>
      </li>
      <li [class.active]="currentRoute === '/shows'">
        <a href="/shows">Shows</a>
      </li>
      <li [class.active]="currentRoute === '/gallery'">
        <a href="/gallery">Gallery</a>
      </li>
      <li [class.active]="currentRoute === '/about'">
        <a href="/about">About</a>
      </li>
      <li [class.active]="currentRoute === '/contact'">
        <a href="/contact">Contact</a>
      </li>
    </ul>
  </div>
</div>

<div class="site-wrap">
  <div class="site-navbar mt-4">
    <div class="container py-1">
      <div class="row align-items-center px-3">
        <div class="col-8 col-md-8 col-lg-4">
          <h1 class="mb-0">
            <a href="/home" class="text-white no-line h2 mb-0"
              ><strong>Argon<span class="text-primary">.</span></strong></a
            >
          </h1>
        </div>
        <div class="col-4 col-md-4 col-lg-8">
          <nav
            class="site-navigation text-right text-md-right"
            role="navigation"
          >
            <div class="d-inline-block d-lg-none ml-md-0 py-3">
              <a class="site-menu-toggle js-menu-toggle text-white"
                ><span class="icon-menu h3" (click)="toggleMobileMenu()"></span
              ></a>
            </div>

            <ul class="site-menu js-clone-nav d-none d-lg-block">
              <li [class.active]="currentRoute === '/home'">
                <a href="/home">Home</a>
              </li>
              <li [class.active]="currentRoute === '/music'">
                <a href="/music">Music</a>
              </li>
              <li [class.active]="currentRoute === '/shows'">
                <a href="/shows">Shows</a>
              </li>
              <li [class.active]="currentRoute === '/gallery'">
                <a href="/gallery">Gallery</a>
              </li>
              <li [class.active]="currentRoute === '/about'">
                <a href="/about">About</a>
              </li>
              <li [class.active]="currentRoute === '/contact'">
                <a href="/contact">Contact</a>
              </li>
            </ul>
          </nav>
        </div>
      </div>
    </div>
  </div>
</div>
